import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Select from 'react-select';
import { IoMdClose } from "react-icons/io";
import { authHeader } from "../../../services/auth-header";
import { BASE_URL } from "../../../services/Api";
import debounce from 'lodash/debounce';
import CommonInspectionFields from "../CommonInspectionFields";

const MDPOTOIConvert = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(true);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [rows, setRows] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
    const [CommonFieldsData, setCommonFieldsData] = useState({
        podate: '',
        enquiryno: '',
        enquirydate: '',
        receivedate: '',
        pono: '',
        status: '',
        shipto: '',
        deliverynoteno: '',
        deliverynotedate: '',
        supplier: null,
        supplierDetails: {
            contactperson: '',
            contactno: '',
            email: ''
        },
        supplierMultipleAddress: null,
        branch: null,
        warehouse: null
    });

    const unitOptions = [
        { value: "", label: "Select UOM" },
        { value: "bot", label: "Bot" },
        { value: "ctn", label: "Ctn" },
        { value: "days", label: "Days" },
        { value: "ft", label: "Ft" },
        { value: "hrs", label: "Hrs" },
        { value: "kg", label: "Kg" },
        { value: "ltr", label: "Ltr" },
        { value: "mtr", label: "Mtr" },
        { value: "nos", label: "Nos" },
        { value: "pil", label: "Pil" },
        { value: "pkt", label: "Pkt" },
        { value: "set", label: "Set" },
        { value: "pcs", label: "Pcs" }
    ];

    const [inspectionreportdate, setinspectionreportdate] = useState('');
    const [jobnumber, setjobnumber] = useState("");


    // Fetch product data with debounced search
    const handleProductSearchChange = debounce((inputValue) => {
        setProductSearch(inputValue ? encodeURIComponent(inputValue) : encodeURIComponent(" "));
    }, 500);

    const getPumpProductData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
                { headers: authHeader() }
            );

            const products = response.data.Index || response.data.data || [];
            setProductOptions(
                products.map(product => ({
                    value: product.id,
                    label: `${product.description} - ${product.itemcode} - ${product.serialnumber} - ${product.moc} - ${product.partno}`,
                    description: product.description,
                    partno: product.partno,
                    serialnumber: product.serialnumber,
                    igst: product.igst,
                    modelnumber: product.modelnumber,
                    tagnumber: product.tagnumber,
                    hsnsacno: product.hsnsacno,
                    uom: product.unitofmeasurement || unitOptions[0].value,
                    moc: product.moc || "",
                    type: product.type || "",
                    size: product.size || "",
                    rating: product.rating || "",
                    classes: product.classes || "",
                    schedule: product.schedule || "",
                    certification: product.certification || "",
                }))
            );
        } catch (error) {
            console.error("Error fetching products", error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to fetch Product. Please try again.",
            });
        }
    };

    const getPurchaseOrderDetails = async () => {
        try {
            const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
                headers: authHeader(),
            });
            const data = response.data;
            setjobnumber(data.jobnumber);

            // Set main form data
            setCommonFieldsData({
                podate: data.podate || '',
                enquiryno: data.enquiryno || '',
                enquirydate: data.enquirydate || '',
                receivedate: data.receivedate || '',
                pono: data.pono || '',
                status: data.status || '',
                shipto: data.shipto || '',
                deliverynoteno: data.deliverynoteno || '',
                deliverynotedate: data.deliverynotedate || '',
                supplier: data.supplier ? {
                    value: data.supplier.id,
                    label: data.supplier.companyname
                } : null,
                supplierDetails: {
                    contactperson: data.contactperson || '',
                    contactno: data.contactno || '',
                    email: data.email || ''
                },
                supplierMultipleAddress: data.supplierMultipleAddress ? {
                    value: data.supplierMultipleAddress.id,
                    label: data.supplierMultipleAddress.supplieraddress
                } : null,
                branch: data.branch ? {
                    value: data.branch.id,
                    label: data.branch.branchname
                } : null,
                warehouse: data.warehouse ? {
                    value: data.warehouse.id,
                    label: data.warehouse.warehousename
                } : null
            });

            // Set product rows
            setRows(data.purchaseOrderItems.map(item => ({
                product: { id: item.product.id, name: item.product.description },
                quantity: item.quantityreceived,
                unitrateinr: item.unitrateinr,
                totalinr: item.totalinr,
                uom: item.uom,
                productremarks: item.productremarks,
                partno: item.partno,
                hsnsacno: item.hsnsacno,
                serialnumber: item.serialnumber,
                igst: item.gst,
                moc: item.moc,
                type: item.type,
                size: item.size,
                rating: item.rating,
                classes: item.classes,
                schedule: item.schedule,
                certification: item.certification,
                mtrno: item.mtrno,
                detailmaterialdescription: item.detailmaterialdescription,
                visualinspection: item.visualinspection,
                dimensionalinspection: item.dimensionalinspection,
                markingonmaterial: item.markingonmaterial,
                verificationofmtr: item.verificationofmtr,
                remarksifany: item.remarksifany,
                measuringinstruments: item.measuringinstruments,
                inspectionmark: item.inspectionmark,
                quantityreceived: item.quantity,
                quantityaccepted: item.quantityaccepted,
                calibrationvalidupto: item.calibrationvalidupto,
                make: item.make,
                heatnobatchno: item.heatnobatchno,
                platenosrno: item.platenosrno,
            })));

            setIsFetching(false);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch inspection report details. Please try again.',
            });
            setIsFetching(false);
        }
    };

    useEffect(() => {
        getPurchaseOrderDetails();
    }, [id]);

    useEffect(() => {
        if (!isFetching) {
            getPumpProductData();
        }
    }, [productSearch, isFetching]);

    const handleProductChange = (selectedOption) => {
        setSelectedProduct(null);
        const selectedProductData = productOptions.find(product => product.value === selectedOption.value);
        if (selectedProductData) {
            const newRow = {
                product: { id: selectedOption.value, name: selectedOption.label },
                productremarks: "",
                hsnsacno: selectedProductData.hsnsacno,
                partno: selectedProductData.partno,
                serialnumber: selectedProductData.serialnumber,
                uom: selectedProductData.uom || unitOptions[0].value,
                igst: selectedProductData.igst,
                moc: selectedProductData.moc || "",
                type: selectedProductData.type || "",
                size: selectedProductData.size || "",
                rating: selectedProductData.rating || "",
                classes: selectedProductData.classes || "",
                schedule: selectedProductData.schedule || "",
                certification: selectedProductData.certification || "",
                quantity: '',
                unitrateinr: '',
                totalinr: 0,
                mtrno: "",
                detailmaterialdescription: "",
                visualinspection: "",
                dimensionalinspection: "",
                markingonmaterial: "",
                verificationofmtr: "",
                remarksifany: "",
                measuringinstruments: "",
                inspectionmark: "",
                quantityreceived: "",
                quantityaccepted: "",
                calibrationvalidupto: "",
                make: "",
                heatnobatchno: "",
                platenosrno: ""
            };
            setRows([...rows, newRow]);
        }
    };


    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;
        setRows(updatedRows);
    };

    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };

    const validateForm = () => {
        if (!CommonFieldsData.supplier) {
            Swal.fire("Missing Supplier", "Please select a supplier before submitting the form.", "error");
            return false;
        }

        if (!CommonFieldsData.supplierMultipleAddress) {
            Swal.fire("Missing Address", "Please select the supplier's address.", "error");
            return false;
        }

        if (!CommonFieldsData.branch) {
            Swal.fire("Missing Branch", "Please select a branch.", "error");
            return false;
        }

        if (!CommonFieldsData.warehouse) {
            Swal.fire("Missing Warehouse", "Please select a warehouse.", "error");
            return false;
        }

        if (rows.length === 0) {
            Swal.fire("No Products Added", "Please add at least one product to continue.", "error");
            return false;
        }

        for (const row of rows) {
            if (!row.quantityaccepted || isNaN(row.quantityaccepted) || row.quantityaccepted <= 0) {
                Swal.fire(
                    "Invalid quantity accepted",
                    "Each product must have a valid quantity accepted greater than 0.",
                    "error"
                );
                return false;
            }
        }

        return true;
    };
    const handleSubmit = async () => {


        if (!validateForm()) return;

        setIsLoading(true);

        try {
            // Prepare inspection report items
            const inspectionReportItems = rows.map(row => ({
                product: { id: row.product.id },
                productremarks: row.productremarks || '',
                partno: row.partno || '',
                hsnsacno: row.hsnsacno || '',
                serialnumber: row.serialnumber || '',
                uom: row.uom || '',
                gst: row.igst || 0,
                unitrateinr: parseFloat(row.unitrateinr) || 0,
                quantity: parseFloat(row.quantity) || 0,
                totalinr: parseFloat(row.totalinr) || 0,
                moc: row.moc || '',
                type: row.type || '',
                size: row.size || '',
                rating: row.rating || '',
                classes: row.classes || '',
                schedule: row.schedule || '',
                certification: row.certification || '',
                mtrno: row.mtrno || '',
                detailmaterialdescription: row.detailmaterialdescription || '',
                visualinspection: row.visualinspection || '',
                dimensionalinspection: row.dimensionalinspection || '',
                markingonmaterial: row.markingonmaterial || '',
                verificationofmtr: row.verificationofmtr || '',
                remarksifany: row.remarksifany || '',
                measuringinstruments: row.measuringinstruments || '',
                inspectionmark: row.inspectionmark || '',
                quantityreceived: parseFloat(row.quantityreceived) || 0,
                quantityaccepted: parseFloat(row.quantityaccepted) || 0,
                calibrationvalidupto: row.calibrationvalidupto || '',
                make: row.make || '',
                heatnobatchno: row.heatnobatchno || '',
                platenosrno: row.platenosrno || ''
            }));


            const inspectionReportData = {

                inspectionReportItems,
                inspectionreporttype: 'Manufacturing',
                inspectionreportcategory: 'Domestic',
                // Common MRN fields
                jobnumber,
                inspectionreportdate,
                podate: CommonFieldsData.podate,
                enquiryno: CommonFieldsData.enquiryno,
                enquirydate: CommonFieldsData.enquirydate,
                receivedate: CommonFieldsData.receivedate,
                pono: CommonFieldsData.pono,
                status: CommonFieldsData.status,
                shipto: CommonFieldsData.shipto,
                mrnno: CommonFieldsData.mrnno,
                mrndate: CommonFieldsData.mrndate,
                deliverynoteno: CommonFieldsData.deliverynoteno,
                deliverynotedate: CommonFieldsData.deliverynotedate,
                supplier: CommonFieldsData.supplier ? { id: CommonFieldsData.supplier.value } : null,
                contactperson: CommonFieldsData.supplierDetails.contactperson,
                contactno: CommonFieldsData.supplierDetails.contactno,
                email: CommonFieldsData.supplierDetails.email,
                supplierMultipleAddress: CommonFieldsData.supplierMultipleAddress ? { id: CommonFieldsData.supplierMultipleAddress.value } : null,
                branch: CommonFieldsData.branch ? { id: CommonFieldsData.branch.value } : null,
                warehouse: CommonFieldsData.warehouse ? { id: CommonFieldsData.warehouse.value } : null
            };

            // Make the API call
            const response = await axios.post(`${BASE_URL}inspectionReport/mrnToInspectionReport/${id}`,
                inspectionReportData,
                { headers: authHeader() }
            );

            // Show success message
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Converted successfully!',
            }).then(() => {
                navigate("/irindex/1");
            });
        } catch (error) {
            console.error("Error updating inspection report:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to update inspection report. Please try again.',
            });
        } finally {
            setIsLoading(false);
        }
    };
    if (isFetching) {
        return (
            <div className="container text-center mt-5">
                <Spinner animation="border" variant="primary" />
                <p>Loading inspection report data...</p>
            </div>
        );
    }

    return (
        <div className="container">
            <br></br>
            <Form>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Inspection Report  Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={inspectionreportdate}
                                onChange={e => setinspectionreportdate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Job Number</Form.Label>
                            <Form.Control
                                type="text"
                                value={jobnumber}
                                onChange={(e) => setjobnumber(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <CommonInspectionFields
                    initialData={CommonFieldsData}
                    onDataChange={setCommonFieldsData}
                    isEditMode={true}
                />
                <hr />
                <br />
                {/* Product Selection Section */}
                <Row>
                    <Col md='12'>
                        <Form.Group>
                            <Form.Label>Products:</Form.Label>
                            <Select
                                value={selectedProduct}
                                onChange={handleProductChange}
                                options={productOptions}
                                placeholder="Search and select product"
                                onInputChange={handleProductSearchChange}
                                isClearable
                                noOptionsMessage={() => "No products found"}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <br />


                {/* Products Table */}
                {rows.length > 0 ? (
                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            backgroundColor: '#fff',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                            borderRadius: '8px',
                            overflow: 'hidden'
                        }}>
                            <thead style={{
                                backgroundColor: '#f8f9fa',
                                borderBottom: '2px solid #dee2e6'
                            }}>
                                <tr>
                                    <th style={tableHeaderStyle}>Product Details</th>
                                    <th style={tableHeaderStyle}>Material & MTR</th>
                                    <th style={tableHeaderStyle}>Inspections</th>
                                    <th style={tableHeaderStyle}>Quantities</th>
                                    <th style={tableHeaderStyle}>Identification</th>
                                    <th style={tableHeaderStyle}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, index) => (
                                    <tr key={index} style={{
                                        borderBottom: '1px solid #dee2e6',
                                        transition: 'background-color 0.2s ease'
                                    }}>
                                        {/* Product Details Column */}
                                        <td style={tableCellStyle}>
                                            <div style={{
                                                fontWeight: '600',
                                                color: '#2c3e50',
                                                fontSize: '14px',
                                                marginBottom: '8px'
                                            }}>
                                                {row.product.name}
                                            </div>
                                            <hr style={{
                                                margin: '8px 0',
                                                border: 'none',
                                                borderTop: '1px solid #e9ecef'
                                            }} />
                                            <div style={{ padding: '4px 0' }}>
                                                {[
                                                    { label: 'MOC', value: row.moc, name: 'moc' },
                                                    { label: 'Type', value: row.type, name: 'type' },
                                                    { label: 'Size', value: row.size, name: 'size' },
                                                    { label: 'Rating', value: row.rating, name: 'rating' },
                                                    { label: 'Class', value: row.classes, name: 'classes' },
                                                    { label: 'Schedule', value: row.schedule, name: 'schedule' },
                                                    { label: 'Certification', value: row.certification, name: 'certification' },
                                                ].map((item, idx) => (
                                                    <div key={idx} style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        marginBottom: '6px',
                                                        gap: '8px'
                                                    }}>
                                                        <span style={{
                                                            fontSize: '12px',
                                                            fontWeight: '500',
                                                            color: '#495057',
                                                            minWidth: '80px',
                                                            flexShrink: 0
                                                        }}>{item.label}:</span>
                                                        <input
                                                            type="text"
                                                            value={item.value}
                                                            onChange={(e) => handleRowChange(index, item.name, e.target.value)}
                                                            style={inputStyle}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </td>

                                        {/* Material & MTR Column */}
                                        <td style={tableCellStyle}>
                                            <label style={labelStyle}>Material Desc:</label>
                                            <textarea
                                                rows="3"
                                                value={row.detailmaterialdescription}
                                                onChange={(e) => handleRowChange(index, 'detailmaterialdescription', e.target.value)}
                                                style={textareaStyle}
                                            />

                                            <label style={labelStyle}>MTR No:</label>
                                            <input
                                                type="text"
                                                value={row.mtrno}
                                                onChange={(e) => handleRowChange(index, 'mtrno', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Remarks:</label>
                                            <textarea
                                                rows="2"
                                                value={row.remarksifany}
                                                onChange={(e) => handleRowChange(index, 'remarksifany', e.target.value)}
                                                style={textareaStyle}
                                            />
                                        </td>

                                        {/* Inspections Column */}
                                        <td style={tableCellStyle}>
                                            {[
                                                { label: 'Visual', name: 'visualinspection', value: row.visualinspection },
                                                { label: 'Dimensional', name: 'dimensionalinspection', value: row.dimensionalinspection },
                                                { label: 'Marking', name: 'markingonmaterial', value: row.markingonmaterial },
                                                { label: 'MTR Verify', name: 'verificationofmtr', value: row.verificationofmtr }
                                            ].map((inspection, idx) => (
                                                <div key={idx} style={{ marginBottom: '8px' }}>
                                                    <label style={labelStyle}>{inspection.label}:</label>
                                                    <select
                                                        value={inspection.value}
                                                        onChange={(e) => handleRowChange(index, inspection.name, e.target.value)}
                                                        style={selectStyle}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                        {(inspection.label !== 'Visual' && inspection.label !== 'Dimensional') && (
                                                            <option value="NA">N/A</option>
                                                        )}
                                                    </select>
                                                </div>
                                            ))}

                                            <label style={labelStyle}>Instruments:</label>
                                            <input
                                                type="text"
                                                value={row.measuringinstruments}
                                                onChange={(e) => handleRowChange(index, 'measuringinstruments', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Mark:</label>
                                            <input
                                                type="text"
                                                value={row.inspectionmark}
                                                onChange={(e) => handleRowChange(index, 'inspectionmark', e.target.value)}
                                                style={inputStyle}
                                            />
                                        </td>

                                        {/* Quantities Column */}
                                        <td style={tableCellStyle}>
                                            <label style={labelStyle}>Received:</label>
                                            <input
                                                type="number"
                                                value={row.quantityreceived}
                                                onChange={(e) => handleRowChange(index, 'quantityreceived', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Accepted:</label>
                                            <input
                                                type="number"
                                                value={row.quantityaccepted}
                                                onChange={(e) => handleRowChange(index, 'quantityaccepted', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>UOM:</label>
                                            <Select
                                                value={unitOptions.find(option => option.value === row.uom)}
                                                onChange={(selected) => handleRowChange(index, 'uom', selected.value)}
                                                options={unitOptions}
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                menuPortalTarget={document.body}

                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '32px',
                                                        fontSize: '13px',
                                                        border: '1px solid #ced4da',
                                                        borderRadius: '4px'
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        padding: '4px'
                                                    })
                                                }}
                                            />
                                        </td>

                                        {/* Identification Column */}
                                        <td style={tableCellStyle}>
                                            <label style={labelStyle}>Make:</label>
                                            <input
                                                type="text"
                                                value={row.make}
                                                onChange={(e) => handleRowChange(index, 'make', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Heat/Batch No:</label>
                                            <input
                                                type="text"
                                                value={row.heatnobatchno}
                                                onChange={(e) => handleRowChange(index, 'heatnobatchno', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Plate/Sr No:</label>
                                            <input
                                                type="text"
                                                value={row.platenosrno}
                                                onChange={(e) => handleRowChange(index, 'platenosrno', e.target.value)}
                                                style={inputStyle}
                                            />

                                            <label style={labelStyle}>Calibration Valid:</label>
                                            <input
                                                type="date"
                                                value={row.calibrationvalidupto}
                                                onChange={(e) => handleRowChange(index, 'calibrationvalidupto', e.target.value)}
                                                style={{
                                                    ...inputStyle,
                                                    fontSize: '13px'
                                                }}
                                            />
                                        </td>

                                        {/* Action Column */}
                                        <td style={{
                                            ...tableCellStyle,
                                            verticalAlign: 'middle',
                                            textAlign: 'center'
                                        }}>
                                            <button
                                                onClick={() => removeRow(index)}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: '#dc3545',
                                                    cursor: 'pointer',
                                                    padding: '4px',
                                                    borderRadius: '4px',
                                                    transition: 'background-color 0.2s ease'
                                                }}
                                                onMouseOver={(e) => e.target.style.backgroundColor = '#f8d7da'}
                                                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                                                title="Remove item"
                                            >
                                                <IoMdClose size={20} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{
                        padding: '20px',
                        backgroundColor: '#d1ecf1',
                        border: '1px solid #bee5eb',
                        borderRadius: '4px',
                        color: '#0c5460',
                        textAlign: 'center'
                    }}>
                        No products added yet. Please search and select products above.
                    </div>
                )}
                <br />
                <button className="button-70" type="button" onClick={handleSubmit}>
                    {isLoading ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" />
                            {' Converting...'}
                        </>
                    ) : 'CONVERT'}
                </button>
            </Form>
        </div>
    );
};

export default MDPOTOIConvert;



// Common style objects
const tableHeaderStyle = {
    padding: '12px 8px',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: '13px',
    color: '#495057',
    borderBottom: '1px solid #dee2e6',
    backgroundColor: '#f8f9fa'
}

const tableCellStyle = {
    padding: '12px 8px',
    verticalAlign: 'top',
    border: '1px solid #dee2e6',
    fontSize: '13px'
}

const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: '500',
    color: '#6c757d',
    marginBottom: '4px',
    marginTop: '8px'
}

const inputStyle = {
    width: '100%',
    padding: '6px 8px',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    fontSize: '13px',
    boxSizing: 'border-box'
}

const textareaStyle = {
    ...inputStyle,
    resize: 'vertical',
    minHeight: '60px',
    fontFamily: 'inherit'
}

const selectStyle = {
    ...inputStyle,
    cursor: 'pointer'
}